/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import2 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import3 from '../../orchestration/page';
import * as import4 from '../../orchestration/navigation.service';
import * as import5 from './customer-notes-edit-page.component';
import * as import6 from '../../inputs/text-area-field/text-area-field.component.ngfactory';
import * as import7 from '../../inputs/text-area-field/text-area-field.component';
import * as import8 from '@angular/forms';
import * as import9 from '../../buttons/button/button.component.ngfactory';
import * as import10 from '../../buttons/button/button.component';
import * as import11 from '../../orchestration/session.model';
import * as import12 from '../../orchestration/responsive.service';
import * as import13 from '../../page-layout/page-footer-control.directive';
import * as import14 from '../ordering-context.model';
const styles_CustomerNotesEditPageComponent:any[] = ([] as any[]);
export const RenderType_CustomerNotesEditPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_CustomerNotesEditPageComponent,
  data: {}
}
);
export function View_CustomerNotesEditPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),16,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import1.View_ModalPageLayoutComponent_0,import1.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import2.ModalPageLayoutComponent,[
      import3.Page,
      import4.NavigationService
    ]
      ,{title: [
        0,
        'title'
      ]
    },(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import3.PageLayout,(null as any),[import2.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),4,5,'woa-text-area-field',[[
        'name',
        'message'
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.CustomerNotesEditPageComponent = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.notes = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import6.View_TextAreaFieldComponent_0,import6.RenderType_TextAreaFieldComponent)),
    import0.ɵdid(180224,(null as any),0,import7.TextAreaFieldComponent,[import0.ChangeDetectorRef],(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import8.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import7.TextAreaFieldComponent]),
    import0.ɵdid(671744,(null as any),0,import8.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import8.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import8.NgControl,(null as any),[import8.NgModel]),
    import0.ɵdid(16384,(null as any),0,import8.NgControlStatus,[import8.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),7,2,'woa-button',[[
        'woa-page-footer-control',
        ''
      ]
    ],[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import5.CustomerNotesEditPageComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,15).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.confirmNotes()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import9.View_ButtonComponent_0,import9.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import10.ButtonComponent,[
      import0.ElementRef,
      import11.SessionModel,
      import0.ChangeDetectorRef,
      import12.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        3,
        4
      ]
    ],0,import13.PageFooterControlDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import5.CustomerNotesEditPageComponent = v.component;
    const currVal_0:any = 'woa.heading.order.notes';
    ck(v,2,0,currVal_0);
    const currVal_8:any = 'message';
    const currVal_9:any = co.notes;
    ck(v,10,0,currVal_8,currVal_9);
    const currVal_37:any = 'woa.button.common.continue';
    ck(v,15,0,currVal_37);
  },(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,12).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,12).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,12).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,12).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,12).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,12).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,12).ngClassPending;
    ck(v,7,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_10:any = import0.ɵnov(v,15).overrideFlatBackgroundColor;
    const currVal_11:any = import0.ɵnov(v,15).overrideFlatForegroundColor;
    const currVal_12:any = import0.ɵnov(v,15).overrideOutlineBackgroundColor;
    const currVal_13:any = import0.ɵnov(v,15).overrideOutlineForegroundColor;
    const currVal_14:any = import0.ɵnov(v,15).overrideOutlineBorderColor;
    const currVal_15:any = import0.ɵnov(v,15).overrideRaisedBackgroundColor;
    const currVal_16:any = import0.ɵnov(v,15).overrideRaisedForegroundColor;
    const currVal_17:any = import0.ɵnov(v,15).disabled;
    const currVal_18:any = import0.ɵnov(v,15).invisible;
    const currVal_19:any = import0.ɵnov(v,15).hovered;
    const currVal_20:any = import0.ɵnov(v,15).native;
    const currVal_21:any = import0.ɵnov(v,15).button;
    const currVal_22:any = import0.ɵnov(v,15).firstTier;
    const currVal_23:any = import0.ɵnov(v,15).secondTier;
    const currVal_24:any = import0.ɵnov(v,15).highProminence;
    const currVal_25:any = import0.ɵnov(v,15).lowProminence;
    const currVal_26:any = import0.ɵnov(v,15).affirmativeConnotation;
    const currVal_27:any = import0.ɵnov(v,15).dissuasiveConnotation;
    const currVal_28:any = import0.ɵnov(v,15).negativeConnotation;
    const currVal_29:any = import0.ɵnov(v,15).squareShape;
    const currVal_30:any = import0.ɵnov(v,15).roundedShape;
    const currVal_31:any = import0.ɵnov(v,15).ovalShape;
    const currVal_32:any = import0.ɵnov(v,15).flatStyle;
    const currVal_33:any = import0.ɵnov(v,15).outlineStyle;
    const currVal_34:any = import0.ɵnov(v,15).raisedStyle;
    const currVal_35:any = import0.ɵnov(v,15).verticalLayout;
    const currVal_36:any = import0.ɵnov(v,15).horizontalLayout;
    ck(v,14,1,[
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26,
      currVal_27,
      currVal_28,
      currVal_29,
      currVal_30,
      currVal_31,
      currVal_32,
      currVal_33,
      currVal_34,
      currVal_35,
      currVal_36
    ]
    );
  });
}
function View_CustomerNotesEditPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-customer-notes-edit-page',([] as any[]),(null as any),(null as any),(null as any),View_CustomerNotesEditPageComponent_0,RenderType_CustomerNotesEditPageComponent)),
    import0.ɵdid(49152,(null as any),0,import5.CustomerNotesEditPageComponent,[
      import14.OrderingContextModel,
      import4.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import3.Page,(null as any),[import5.CustomerNotesEditPageComponent])
  ]
  ,(null as any),(null as any));
}
export const CustomerNotesEditPageComponentNgFactory:import0.ComponentFactory<import5.CustomerNotesEditPageComponent> = import0.ɵccf('woa-customer-notes-edit-page',import5.CustomerNotesEditPageComponent,View_CustomerNotesEditPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/ordering-context/customer-notes-edit-page/customer-notes-edit-page.component.ngfactory.ts